var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/logo1-1.png")}}),_c('div',{staticClass:"title"},[_c('span',[_vm._v("执数智之器 · 精水务之业")])]),_c('img',{staticClass:"downScroll",attrs:{"src":require("@/assets/img/pc/icon1.gif")}})])
}]

export { render, staticRenderFns }